import { useQuery } from "@apollo/client";
import { useAuth0 } from "@auth0/auth0-react";
import { constantsData } from "data";
import { getDistributionsListQuery } from "graph";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { openAlert } from "redux/actions";
import { displayErrorHandler } from "utils";

const useDistributionsList = (releaseId) => {
    const [params] = useSearchParams();

    const [cursor, setCursor] = useState(null);

    const dispatch = useDispatch();

    const pageParam = parseInt(params.get("page")) || 1;

    const limitParam = parseInt(params.get("limit")) || 25;

    const [page, setPage] = useState(pageParam);

    const [limit, setLimit] = useState(limitParam);

    const { isAuthenticated } = useAuth0();

    const { t } = useTranslation();

    const {
        data,
        error,
        loading,
        startPolling,
        stopPolling,
    } = useQuery(
        getDistributionsListQuery,
        {
            skip: !isAuthenticated,
            variables: {
                ...cursor ? { cursor } : {},
                limit,
                page: page - 1,
                ...releaseId && { releaseId },
            },
        },
    );

    useEffect(
        () => {
            if (error?.message === constantsData.failedToFetch && !loading) {
                displayErrorHandler(
                    t("messages.networkFailure"),
                    dispatch,
                    openAlert,
                );
            }
        },
        [error, data], // eslint-disable-line
    );

    return {
        count: data?.listDistributions?.meta?.resultCount,
        data: data?.listDistributions?.posts,
        limit,
        loading,
        nextCursor: data?.listDistributions?.meta?.nextCursor,
        page: data?.listDistributions?.meta?.currentPage,
        prevCursor: data?.listDistributions?.meta?.prevCursor,
        setCursor,
        setLimit,
        setPage,
        startPolling,
        stopPolling,
    };
};

export default useDistributionsList;
